import React, { Component, PropTypes } from 'react';
import { debounce, uniqueId, concat, uniqBy, find } from 'lodash';
import { Link } from 'react-router';
import axios from 'axios';

import { casesRoute, generateURL, pageRoute, jobsRoute, profilesRoute } from '../../../routes';
import connect from '../../../utils/connect';
import baseUrl from '../../../utils/baseUrl';
import { DateFormatter } from '../../../utils/date';
import formatCredits from '../../../utils/formatCredits';

import Image from '../../image/image';
import Spinner from '../../svg/spinner';

import css from './searchPage.scss';

const TYPE_CASE       = 'cases';
const TYPE_EDITORIAL  = 'editorials';
const TYPE_OTHER      = 'other';
const DEFAULT_STATE   = {
	fetching: false,
	init: true,
	value: '',
	results: {
		cases: [],
		editorials: [],
		other: [],
	},
	totalCases: 0,
	totalEditorials: 0,
	totalOther: 0,
	totalCount: 0,
};

export default class SearchPage extends Component {
	static propTypes = {
		searchActive: PropTypes.bool.isRequired,
		browser: PropTypes.object.isRequired,
		menuActions: PropTypes.object.isRequired,
	};

	static defaultProps = {
		searchActive: false,
	};

	constructor(props) {
		super(props);

		this.fetchResults = debounce(this.fetchResults.bind(this), 500);

		this.state = DEFAULT_STATE;
	}

	componentDidUpdate(prevProps, prevState) {
		if (!prevProps.searchActive && this.props.searchActive) {
			this.refs.search && this.refs.search.focus();

			// TODO: Fix in a... better way
			document.querySelector('body').scrollTop = 0;
		}
	}

	render() {
		let className = 'search-page full-span--wborder';

		if (this.props.searchActive) {
			className += ' search-page--active';
		}

		return (
			<div className={className}>

				<div className='search-page__head'>
					Search the FWA
				</div>

				<div className='search-page__input pixel-pattern pixel-pattern--01'>
					<input ref='search' type='text' className='' style={{ tabIndex: 0 }} value={this.state.value} placeholder='Search for cases, agencies, people, locations etc.' onInput={this.searchInput.bind(this)} />
				</div>

				<div className='search-page__result-head'>
					{this.state.fetching ? (
						<Spinner size='24' className='search-page__result-head__spinner' />
					) : (!this.state.init && (
						<span>
							Results <span className='search-page__result-head__count'>({this.state.totalCount})</span>
						</span>
					))}
				</div>

				<SearchPageCategory
					key='cases'
					items={this.state.results.cases}
					title='Cases'
					component={SearchPageCase}
					browser={this.props.browser}
					toggleMenu={this.toggleSearchMenu.bind(this)}
					query={this.state.value}
					type={TYPE_CASE}
					totalCount={this.state.totalCases || 0}
					/>

				<SearchPageCategory
					key='editorial'
					items={this.state.results.editorials}
					title='Editorial'
					component={SearchPageEditorial}
					browser={this.props.browser}
					toggleMenu={this.toggleSearchMenu.bind(this)}
					query={this.state.value}
					type={TYPE_EDITORIAL}
					totalCount={this.state.totalEditorials || 0}
					/>

				<SearchPageCategory
					key='other'
					items={this.state.results.other}
					title='Other'
					component={SearchPageOther}
					browser={this.props.browser}
					toggleMenu={this.toggleSearchMenu.bind(this)}
					query={this.state.value}
					type={TYPE_OTHER}
					totalCount={this.state.totalOther || 0}
					/>

				<div className='cf'></div>
			</div>
		);
	}

	toggleSearchMenu() {
		this.props.menuActions && this.props.menuActions.toggleSearchMenu && this.props.menuActions.toggleSearchMenu();
	}

	searchInput(e) {
		if (!e || !e.target) {
			return false;
		}

		this.fetchResults();

		this.setState({
			...this.state,
			init: false,
			value: e.target.value,
			fetching: true,
		});
	}

	fetchResults() {
		axios.get(baseUrl + '/api/search', {
			params: {
				q: this.state.value,
				limit: 6,
			},
		})
		.then((res) => {
			if (res.data && res.data.results && res.data.total !== undefined) {
				this.setState({
					...this.state,
					results: res.data.results,
					totalCount: res.data.total,
					totalCases: res.data.totalCases,
					totalEditorials: res.data.totalEditorials,
					totalOther: res.data.totalOther,
					fetching: false,
				});
			}
		})
		.catch((res) => {
			// error
			this.setState({
				...this.state,
				fetching: false,
			});
		});
	}
}


class SearchPageCategory extends Component {
	static propTypes = {
		items: PropTypes.array.isRequired,
		type: PropTypes.string.isRequired,
		totalCount: PropTypes.number.isRequired,
		title: PropTypes.string.isRequired,
		component: PropTypes.func.isRequired,
		browser: PropTypes.object.isRequired,
		toggleMenu: PropTypes.func.isRequired,
	};

	static defaultProps = {
		type: 0,
		items: [],
		title: '',
		toggleMenu: () => {},
	};

	constructor(props) {
		super(props);

		this.state = {
			fetching: false,
			offset: 0,
			items: this.props.items,
			shown: [],
		};
	}

	componentWillReceiveProps(nextProps) {
		let newState = {
			...this.state,
		};

		if (this.props.query !== nextProps.query) {
			newState.offset = 6;
		}

		if (this.props.items !== nextProps.items) {
			newState.items = nextProps.items;
			newState.shown = [];
		}

		this.setState(newState);
	}

	render() {
		if (!this.state.items.length) {
			return false;
		}

		var delay = 0;
		let className = 'search-page__result-cat';
		let Component = this.props.component;

		return (
			<div className={className}>
				<aside className='search-page__result-cat__aside span2 span100p-mobile'>
					{this.props.title} <span className='search-page__result-cat__aside__count'>({this.props.totalCount})</span>
				</aside>
				<div className='span14'>
					<div className='search-page__result-cat__pusher span2 span0-mobile'></div>
					<div className='search-page__result-cat__container span12 span100p-mobile'>
						<ol className='search-page__items'>
							{!!this.state.items.length && this.state.items.map((item, i) => {
								// base-delay if component is already show
								let _delay = 0;

								if (!find(this.state.shown, (str) => (str === 'item' + item.id))) {
									// if component hasn't been rendered before we add a delay of +50ms compared to the last element that was delayed
									_delay = delay += 50;
									this.state.shown.push('item' + item.id);
								}

								return (
									<Component
										key={'item' + item.id}
										item={item}
										browser={this.props.browser}
										toggleMenu={this.props.toggleMenu}
										delay={_delay}
									/>
								);
							})}
						</ol>
					</div>

					<div className='cf'></div>

					<div className='search-page__result-cat__pusher span2 span0-mobile'></div>



					{(this.state.items.length < this.props.totalCount) && (
						<a className='search-page__result-cat__loadmore-cont' onClick={this.fetchMore.bind(this)}>
							<div className='span2 span4-tablet span4-mobile pixel-pattern search-page__result-cat__loadmore'>
								<Spinner size='32' className={'search-page__waiting' + (this.state.fetching ? ' search-page__waiting--show' : '')} />
								<span className={'search-page__result-cat__loadmore__arrow' + (!this.state.fetching ? ' search-page__result-cat__loadmore__arrow--show' : '')}></span>
							</div>

							<div className='span10 span8-tablet span10-mobile pixel-pattern search-page__result-cat__loadmore'>
								<span>View more results ({this.props.totalCount - this.state.items.length})</span>
							</div>

							<div className='cf'></div>
						</a>
					) || (
						<a className='search-page__result-cat__loadmore-cont'><div className='cf'></div></a>
					)}
				</div>

				<div className='cf'></div>

			</div>
		);
	}

	fetchMore(e) {
		if (this.state.fetching) {
			return false;
		}

		this.setState({
			...this.state,
			fetching: true,
		});

		axios.get(baseUrl + '/api/search', {
			params: {
				q: this.props.query,
				offset: this.state.offset,
				filter: this.props.type,
				limit: 24,
			},
		})
		.then((res) => {
			if (res.data && res.data.results && res.data.results[this.props.type]) {
				let newItems = uniqBy(
					concat([], this.state.items, res.data.results[this.props.type]),
					(item) => item.id
				);

				this.setState({
					...this.state,
					items: newItems,
					offset: this.state.offset + 24,
					fetching: false,
				});
			}
		})
		.catch((res) => {
			// error
			//console.log(res);
			this.setState({
				...this.state,
				fetching: false,
			});
		});
	}
}

class SearchPageCase extends Component {
	static propTypes = {
		item: PropTypes.object.isRequired,
		browser: PropTypes.object.isRequired,
		delay: PropTypes.number,
		toggleMenu: PropTypes.func.isRequired,
	};

	static defaultProps = {
		delay: 0,
		toggleMenu: () => {},
	};

	constructor(props) {
		super(props);

		this.state = {
			visible: false,
		};
	}

	render() {
		let className = 'search-page__items__item search-page__items__case span2 span4-tablet span14-mobile';
		let item = this.props.item;

		if (!this.state.visible) {
			setTimeout(() => {
				this.setState({
					...this.state,
					visible: true,
				});
			}, 1);
		} else {
			className += ' search-page__items__item--active';
		}

		let profileNames = formatCredits(item.profiles, false, false);

		return (
			<li className={className} style={{ transitionDelay: this.props.delay + 'ms' }}>
				<Link to={casesRoute(item.slug)} onClick={this.props.toggleMenu} className='search-page__items__case__link'>
					<div className='search-page__items__case__img-holder pixel-pattern pixel-pattern--dark'>
						{item.slide1 && (
							<Image img={item.thumbnail} span={{ desktop: 'span4', tablet: 'span4', mobile: 'span14' }} browser={this.props.browser} />
						)}

						{item.slug && (
							<div className='search-page__items__case__overlay'>
								<div className='button button--dark-to-light-anim search-page__items__case__overlay__button'>
									See case
								</div>
							</div>
						)}
					</div>

					<div className='search-page__items__case__content'>
						<h2 className='search-page__items__case__title'>{item.title}</h2>
						<span className='search-page__items__case__byline'>{profileNames}</span>
					</div>
				</Link>
			</li>
		);
	}
}

class SearchPageEditorial extends Component {
	static propTypes = {
		item: PropTypes.object.isRequired,
		browser: PropTypes.object.isRequired,
		delay: PropTypes.number,
		toggleMenu: PropTypes.func.isRequired,
	};

	static defaultProps = {
		delay: 0,
		toggleMenu: () => {},
	};

	constructor(props) {
		super(props);

		this.state = {
			visible: false,
		};
	}

	render() {
		let className = 'search-page__items__item search-page__items__editorial search-page__items__editorial__news-single search-page__items__editorial__news-single--contextual span4 span6-tablet span14-mobile';
		let item = this.props.item;
		let date = new DateFormatter(item.createdDate || '');

		if (!this.state.visible) {
			setTimeout(() => {
				this.setState({
					...this.state,
					visible: true,
				});
			}, 1);
		} else {
			className += ' search-page__items__item--active';
		}

		let userName = (item.users && item.users.name) ? item.users.name : 'Uncredited';

		return (
			<li className={className} style={{ transitionDelay: this.props.delay + 'ms' }}>
				<h2 className='search-page__items__editorial__news-single__title span100p'>{item.title}</h2>
				{(item.users && item.users.name || true) && (
					<span className='search-page__items__editorial__news-single__profile'>By {userName}</span>
				)}
				{item.createdDate && (
					<span className='search-page__items__editorial__news-single__date'>{date.dateMonthAndYear}</span>
				)}
				{item.slug && (
					<div className='search-page__items__editorial__news-single__overlay'>
						<Link onClick={this.props.toggleMenu} to={generateURL(item.types ? item.types.slug : '', item.slug)} className='button button--light-to-dark-anim button--light-to-dark-anim--solid search-page__items__editorial__news-single__button'>
							Read more
						</Link>
					</div>
				)}
			</li>
		);
	}
}

class SearchPageOther extends Component {
	static propTypes = {
		item: PropTypes.object.isRequired,
		browser: PropTypes.object.isRequired,
		delay: PropTypes.number,
		toggleMenu: PropTypes.func.isRequired,
	};

	static defaultProps = {
		delay: 0,
		toggleMenu: () => {},
	};

	constructor(props) {
		super(props);

		this.state = {
			visible: false,
		};
	}

	render() {
		let className = 'search-page__items__item search-page__items__editorial search-page__items__editorial--other search-page__items__editorial__news-single search-page__items__editorial__news-single--contextual span4 span6-tablet span14-mobile';
		let item = this.props.item;

		if (!this.state.visible) {
			setTimeout(() => {
				this.setState({
					...this.state,
					visible: true,
				});
			}, 1);
		} else {
			className += ' search-page__items__item--active';
		}

		let routeFn = () => '/';
		let text = 'Read more';
		switch (item.type) {
			case 'templates':
				routeFn = pageRoute;
				text = 'Go to page';
			break;
			case 'jobs':
				routeFn = jobsRoute;
				text = 'View job';
			break;
			case 'profiles':
				routeFn = profilesRoute;
				text = 'View profile';
			break;
		}

		return (
			<li className={className} style={{ transitionDelay: this.props.delay + 'ms' }}>
				<h2 className='search-page__items__editorial__news-single__title span100p'>{item.title}</h2>
				{item.slug && (
					<div className='search-page__items__editorial__news-single__overlay'>
						<Link onClick={this.props.toggleMenu} to={routeFn(item.slug)} className='button button--light-to-dark-anim button--light-to-dark-anim--solid search-page__items__editorial__news-single__button'>
							{text}
						</Link>
					</div>
				)}
			</li>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/header/searchPage/searchPage.js
 **/